import { render, staticRenderFns } from "./PageMap.vue?vue&type=template&id=08a54bf8&"
import script from "./PageMap.vue?vue&type=script&lang=js&"
export * from "./PageMap.vue?vue&type=script&lang=js&"
import style0 from "./PageMap.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports